import { render, staticRenderFns } from "./AvatarPic.vue?vue&type=template&id=607f7eeb&"
import script from "./AvatarPic.vue?vue&type=script&lang=js&"
export * from "./AvatarPic.vue?vue&type=script&lang=js&"
import style0 from "./AvatarPic.vue?vue&type=style&index=0&id=607f7eeb&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports